import styles from './style.module.scss';
import { ActionModal, Button, PageHeader } from 'components';
import { Col, Table, Row, Divider, Empty } from 'antd';
import { ExcelIcon } from 'icons';
import { Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useCandidates from '../useCandidates';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    handleDownloadExcel,
    updateInProcess,
    loading,
    onChangeTableFilter,
    onDelete,
    pathname,
    navigate,
  } = useCandidates();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Database candidati').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          locale={{
            emptyText: <Empty />,
          }}
          columns={UIHelper.assignTire(columns)}
          dataSource={data.candidates}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: 3000 }}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
      <Routes>
        <Route
          path={':id/view'}
          element={
            <ActionModal
              loading={loading}
              title={t(
                'Cliccando su continua verra’ salvato il log dell’operazione',
              )}
              type={'view'}
              description={''}
              yesBtnText={t('Continua')}
              noBtnText={t('Annulla')}
              onClickOk={() => navigate(UIHelper.getListRoute(pathname, 1))}
              onCancel={() => navigate(UIHelper.getListRoute(pathname, 2))}
            />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
